import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import workingData from '../../data/workingData';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faDownload} from '@fortawesome/free-solid-svg-icons';
import './Works.css';
import WorksCard from './WorksCard';

const Works = () => {
    const dataFirst9 = workingData.slice(0,9);
    const dataFirst18 = workingData.slice(0,18);
    const [data, setData] = useState(dataFirst9);
    const handleDataChange = () => {
        if(data.length === 9){
            setData(dataFirst18);
        }
        else{
            setData(workingData);
        }

    }
    return (
        
        <div className='container-fluid' style={{width:'90%'}}>
            <div className='title-section'>
                <h1>My <span className='blog'>portfolio</span></h1>
                <span className='posts'>Works</span>
            </div>

            <div className="row px-3 px-sm-0">
                {
                    data.map(item => <WorksCard key={item.id} singleItem={item}></WorksCard>)
                    
                }
                <Link onClick={handleDataChange} className={data.length === workingData.length ? 'd-none' : 'button mx-auto mb-5 px-5' }>
                    <span className='btnText px-3'>See More</span>
                </Link>
            </div>
        </div>
    );
};

export default Works;